module.exports = __webpack_public_path__ + "media/logos/cnbc-logo-white-3f9fa163.png";